<template>
  <div>
    <v-autocomplete
      ref="autoinput"
      v-model="tags"
      :items="tagItems"
      item-text="n"
      item-value="n"
      :search-input.sync="search"
      :disabled="!allReady"
      :label="inputMsg.label"
      @change="tagChaged"
      @input="inputChanged"
      chips
      :multiple="inputOpt.multiple"
      clearable
      dense
      return-object
      hide-no-data
      hide-details
      color="blue-grey lighten-2"
      autofocus
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          close
          small
          :input-value="data.selected"
          @click="data.select"
          @click:close="remove(data.item)"
        >
          <v-icon left>{{ getIcon(data.item.g) }}</v-icon>
          {{ data.item.n }}
        </v-chip>
      </template>

      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-icon>
            <v-icon>{{ getIcon(data.item.g) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.n"></v-list-item-title>
            <!-- <v-list-item-subtitle v-html="data.item.g"></v-list-item-subtitle> -->
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { helper } from '../helper.js';

export default {
  props: ['dataItems', 'inputMsg', 'inputOpt', 'allReady'],
  data() {
    return {
      tags: [],
      tagItems: [],
      tagsObj: [],
      search: null,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getIcon(group) {
      let rst;
      switch (group) {
        case 'F':
          rst = 'mdi-flask-outline';
          break;
        case 'S':
          rst = 'mdi-hospital-box';
          break;
        case 'H':
          rst = 'mdi-leaf';
          break;
        case 'B':
          rst = 'mdi-book-open-variant';
          break;
        default:
          rst = 'mdi-map-marker-question-outline';
      }
      return rst;
    },
    inputChanged() {
      this.search = null;
      // this.items = []
      //↓ For clear v-menu slot
      this.$refs.autoinput.blur();
      setTimeout(() => {
        this.$refs.autoinput.focus();
      }, 200);
    },
    tagChaged() {
      helper.log('tagUpdated');
      if( helper.isIterable(this.tags) ){
        helper.log([...this.tags]);
        this.$emit('tagUpdated', [...this.tags]);
      } else {
        helper.log( this.tags );
        this.$emit('tagUpdated', this.tags );
      }
    },
    remove(item) {
      helper.log(item);
      
      if( !helper.isIterable(this.tags) ){
        this.tags = {}
      } else {
        let index;
        this.tags.forEach((e, i) => {
          if (e.n === item.n && e.g === item.g) index = i;
        });
        if (index >= 0) this.tags.splice(index, 1);
      }
      this.tagChaged();
    },
    fetchEntriesDebounced(val) {
      // cancel pending call
      clearTimeout(this._timerId);
      // delay new call 500ms
      this._timerId = setTimeout(() => {
        helper.log(val);
        this.tagItems = this.dataItems ? this.dataItems : [];
      }, 500);
    },
  },
  watch: {
    search(val) {
      // helper.log( val )
      val && this.fetchEntriesDebounced(val);
    },
  },
};

// REF:
// https://stackoverflow.com/questions/56797737/clearing-out-typed-text-from-a-vuetify-v-autocomplete-after-drop-down-item-is-se
// Vuetify : throttle / debounce v-autocomplete
// https://stackoverflow.com/a/56822735
</script>
